// Unpublished Work © 2020-2022 Deere & Company

import {fetchJsonWrapper} from './utils/fetch-wrapper';
import {adaptLocaleUnderscoreToDash} from './adapters/user';

export const getUser = async (businessActivities) => {
    const user = await fetchJsonWrapper('/api/user', {
        businessActivities,
        withLocale: true
    });

    return {
        ...user,
        locale: adaptLocaleUnderscoreToDash(user.locale)
    };
};
